module.exports = __webpack_public_path__ + "cbf8d7fe5fcd2db5b2a803f3cf8d61ae.html";


//////////////////
// WEBPACK FOOTER
// ./src/portal/states/company/user-directories/manage-account/details/account-details.html
// module id = 2061
// module chunks = 0